import { Button, Container, IconButton, Typography } from "@mui/material";
import { TbError404 } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';

export const NotFoundPage:React.FC<{}> = () => {
    let history = useNavigate();

    const handleGoBack = () => {
      history(-1);
    };

    return(
        <Container maxWidth="sm" sx={{mt:8}}>
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Typography variant="h4" component="h1">
              Página no encontrada
            </Typography>
            <IconButton aria-label="delete" color="error" sx={{ fontSize: '360px'}} >
            <TbError404 />
            </IconButton>
            <Typography variant="body1">¡Lo siento, pero la página que estás buscando no existe o se encuentra bloqueada temporalmente!</Typography>
            <Typography variant="body1">Por favor, verifica la URL e intenta nuevamente más tarde.</Typography>
            <Typography variant="body1">Si el problema persiste, no dudes en ponerte en contacto con nuestro equipo de soporte para obtener ayuda.</Typography>
            <Typography variant="body1">Lamentamos las molestias y agradecemos tu comprensión.</Typography>
            <Typography variant="body1">¡Gracias!</Typography>            
            <br />
            <Button variant="contained" aria-label="delete" color="primary" onClick={handleGoBack}>
            VOLVER
            </Button>         
          </div>
        </Container>
    );
}